import { OPERANDS, API_OPERAND, WIDGETS_TYPE, WIDGETS_STATE } from "@/enums/filter.enum";
import { SuffixType } from "@/types/app/filter.type";
import { ColumnFilterInterface } from "@/interface/app/filter.interface";
import { Suffix } from "./suffix";
export class ColumnFilter implements ColumnFilterInterface {
  title: string = "";
  queryName: string = "";
  suffixes: Array<SuffixType> = [];
  widgetState: string = WIDGETS_STATE.CLOSED;
  options: Array<any> = [];
  operands: Array<any> = [];
  type: string = "";
  value: any = "";
  schema: any = {};
  name: string = "";

  constructor(data) {
    if (data) {
      this.title = data.title;
      this.queryName = data.queryName;
      this.suffixes = data.suffixes?.map((suffix) => new Suffix(suffix));
      this.options = data.options;
      this.value = data?.value || "";
      this.type = data?.type || "";
      this.name = data?.name || "";
      this.setOperands();
    }
  }

  private getSelectedSuffix(): SuffixType {
    return this.suffixes.find((suffix) => suffix.selected) || new Suffix({});
  }

  public getQuery(): string {
    if (!this.value) {
      return "";
    }
    if (typeof this.value === "object" && this.value?.length > 0) {
      return (
        `${this.queryName}${this.schema.operand}=` +
          this.value.flatMap((item) => item.id || item).join(`&${this.queryName}${this.schema.operand}=`) || ""
      );
    }
    if (this.type === WIDGETS_TYPE.SPECIAL) {
      return "";
    }
    return `${this.schema.queryName}${this.schema.operand}=${this.schema.queryValue}`;
  }
  private setOperands() {
    this.operands = this.suffixes?.map((suffix) => suffix.operand);
  }

  public unSelectAll() {
    this.suffixes.forEach((s) => (s.selected = false));
  }

  public selectOperand(selectedOperand) {
    this.unSelectAll();
    let suffix = this.suffixes.find((suffix) => selectedOperand === suffix.operand);

    if (suffix) {
      suffix.selected = true;
    } else {
      throw new Error("No SUFFIX");
    }
  }

  public buildSchema() {
    this.schema = {
      queryName: this.queryName,
      operand: this.backEndOperand,
      queryValue: this.value,
    };
  }

  public closWidget(){
    this.widgetState =WIDGETS_STATE.CLOSED
  }
  get componentType(): string {
    return this.getSelectedSuffix().type;
  }

  get componentOperand(): string {
    return this.getSelectedSuffix().operand;
  }

  get backEndOperand(): string {
    switch (this.getSelectedSuffix().operand) {
      case OPERANDS.INCLUDES:
        return API_OPERAND.INCLUDES;
        break;
      case OPERANDS.EXCLUDES:
        return API_OPERAND.EXCLUDES;
        break;
      case OPERANDS.IS_NOT:
        return API_OPERAND.IS_NOT;
        break;
      case OPERANDS.IS:
        return API_OPERAND.IS;
        break;
      default:
        return "";
    }
  }
}
